export enum ConsentType {
  TEMPLATE = 'TEMPLATE',
  LINK = 'LINK',
  FILE = 'FILE',
}
